// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormQuarantine } from '~/utils/interface/quarantine';

export const schema = (t: TFunction): yup.ObjectSchema<IFormQuarantine> => {
  return yup.object().shape({
    inventoryId: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    variantId: yup.string().optional(),
    productId: yup.string().optional(),
    title: yup.string().optional(),
    type: yup.string().optional(),
    startDate: yup.string().optional(),
    endDate: yup.string().optional(),
    quantity: yup.number().required(t('common_validate_field_required', { ns: 'common/base' })),
    description: yup.string().optional(),
    quarantineFile: yup.array().optional(),
  });
};

export const defaultValuesQuarantineForm: IFormQuarantine = {
  inventoryId: EMPTY_STRING,
  quantity: 0,
};
